// # #############################################
// # Title : Bar Chart
// # Authors : Shubham, Atul
// # Date : 15th October 2019
// # Last Modified : July 2019
// # Version : 19.10.03
// # Description : The selection toolbar on the Map
// # ############################################

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';


// const styles = {
//   root: {
//     flexGrow: 1,

//   },
// };

const styles = {
  root: {
    position: 'relative',
    margin: '0.5rem',
    borderRadius: '1rem',
    opacity: '0.9',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
};

function SimpleAppBar(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Toolbar>

          {props.children}

        </Toolbar>
      </AppBar>
    </div>
  );
}

SimpleAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleAppBar);